import React, { FC, useEffect } from "react";
import { Card, Button, Table, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { FrTypes2 } from "../../common/Fr";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { Utils } from "../../common/Utils";
import { FundraisingDlg } from "../../pages/fundraising/components/FundraisingDlg";
import { observer } from "mobx-react";
import { Store } from "../../store/Store";
import moment from "moment";
import { SortOrder } from "antd/lib/table/interface";

export const FundraiserCard: FC<any> = observer(({ style }) => {
  let { id } = useParams<any>();
  const orgStore = Store.orgsStore.orgView;
  // orgStore.active(id);
  const fundsStore = orgStore.fundsStore;
  fundsStore.filter.orgId = id;
  const location = useLocation();

  const history = useHistory();

  useEffect(() => {
    fundsStore.onLocation(location);
  }, []);

  useEffect(() => {
    fundsStore.onLocation(location);
  }, [location.search]);

  // const {
  //   loading,
  //   data: { fundraisers } = { fundraisers: [] },
  //   refetch,
  // } = useQuery(FrFundraisers, {
  //   variables: {
  //     filter: { orgId },
  //   },
  // });

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Fundraiser Name",
      dataIndex: "name",
      key: "name.keyword",
      width: "15%",
      sorter: (a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()),
      render: (t, r) => (
        <div>
          <Link to={`/fundraisers/${r.id}`}>{t}</Link>
          {r.shareCode && <Tag>{r.shareCode}</Tag>}
        </div>
      ),
      sortOrder:
        fundsStore.sortedInfo.columnKey === "name.keyword" ? (fundsStore.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "15%",
      sorter: (a, b) => a.type - b.type,
      render: (t) => FrTypes2[t],
      sortOrder: fundsStore.sortedInfo.columnKey === "type" ? (fundsStore.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Organizer",
      dataIndex: ["funOrg", "name"],
      width: "15%",
      key: "org",
    },
    {
      title: "Duration",
      key: "start",
      width: "15%",
      sorter: (a, b) => moment(b.start).valueOf() - moment(a.start).valueOf(),
      render: (_, r) => Utils.timeDuration(r),
      sortOrder: fundsStore.sortedInfo.columnKey === "start" ? (fundsStore.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Target",
      dataIndex: "target",
      className: "col-money",
      key: "target",
      width: 40,
      sorter: (a, b) => a.target - b.target,
      render: (t) => Utils.fmtMoney(t),
      sortOrder: fundsStore.sortedInfo.columnKey === "target" ? (fundsStore.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Description",
      dataIndex: "description",
      width: "30%",
      key: "description",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "state",
      sorter: true,
      sortOrder: fundsStore.sortedInfo.columnKey === "state" ? (fundsStore.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "",
      key: "opt",
      render: (t, r) => <EditOutlined onClick={() => onEdit(r)} />,
    },
  ];

  const onEdit = (m) => {
    Store.fundsStore.fundEdit.edit(m.id);
  };

  const onPage = (page, pageSize) => {
    fundsStore.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter) => {
    console.log("sorter", sorter);
    fundsStore.sortedInfo = sorter;
    fundsStore.refresh();
  };

  return (
    <Card
      size="small"
      title="Fundraiser"
      style={style}
      bodyStyle={{ padding: 0 }}
      extra={
        <Button size="small" style={{ float: "right" }} onClick={() => fundsStore.refresh()}>
          Refresh
        </Button>
      }
    >
      <Table
        size="small"
        loading={fundsStore.loading}
        rowKey="id"
        onChange={onChange}
        pagination={{ ...fundsStore.pagination, onChange: onPage }}
        columns={columns}
        dataSource={fundsStore.data.items}
      />
      <FundraisingDlg></FundraisingDlg>
    </Card>
  );
});
